import { ChangeDetectionStrategy, Component, EventEmitter, Output } from '@angular/core';

import { DIAGNOSTICS_CONNECTION_STEP, RemoteDiagnosticsStore } from '@store';

import {
  ConnectionReasonFormModelValue,
  RemoteDiagnosticsConnectionReasonsControls,
} from '../diagnostics-connection-reason-collector-form/reasons-form.model';

@Component({
  selector: 'app-diagnostics-connection-reason-collector',
  templateUrl: './diagnostics-connection-reason-collector.component.html',
  styleUrls: ['./diagnostics-connection-reason-collector.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DiagnosticsConnectionReasonCollectorComponent {
  protected isFormInvalid = true;
  protected formValue: ConnectionReasonFormModelValue;

  @Output()
  cancel: EventEmitter<DIAGNOSTICS_CONNECTION_STEP> = new EventEmitter<
    DIAGNOSTICS_CONNECTION_STEP
  >();

  constructor(public remoteDiagnosticsStore: RemoteDiagnosticsStore) {}

  proceedToWarning(): void {
    const reasonType = this.formValue[RemoteDiagnosticsConnectionReasonsControls.ReasonType];
    const ticketNumber = this.formValue[RemoteDiagnosticsConnectionReasonsControls.TicketNumber];
    const descriptionText = this.formValue[
      RemoteDiagnosticsConnectionReasonsControls.DescriptionText
    ];
    const reason = `${reasonType} - ${ticketNumber ? ticketNumber : descriptionText}`;
    this.remoteDiagnosticsStore.saveConnectionReason(reason);
    this.remoteDiagnosticsStore.setActiveConnectionStep(DIAGNOSTICS_CONNECTION_STEP.WARNING);
  }
}
